export default [
  {
    title: "Avtalstyp",
    key: "TYPE",
    visited: true,
    hasError: false,
    fieldKeys: [],
  },
];
